import { DialogActions } from '@mui/material';
import React, { FC } from 'react';
import { useStyles } from './styles';

interface IProps {
  children: React.ReactNode;
}

const ModalFooter: FC<IProps> = ({ children }) => {
  const classes = useStyles();

  return <DialogActions className={classes.root}>{children}</DialogActions>;
};

export default ModalFooter;
